angular.module('smartorg.r6.acts.metalog', []);
require('./metalog-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.acts.metalog';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/metalog/app/js/plumbing/app.js